import { render, staticRenderFns } from "./ItemsMatrix.vue?vue&type=template&id=6e574304&scoped=true&"
import script from "./ItemsMatrix.vue?vue&type=script&lang=js&"
export * from "./ItemsMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e574304",
  null
  
)

export default component.exports